import { render } from "./DivRow.vue?vue&type=template&id=d58e585e&ts=true"
import script from "./DivRow.vue?vue&type=script&lang=ts"
export * from "./DivRow.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__